/**
 * H5与native协议 js文件
 */
(function(win, lib) {

    win.UpH5Native = win.UpH5Native || {};

    let apiStatus = {};
    let iframe = null;
    let urlPrefixCallAppInAndroid = 'uplivecn://goWindow'; // android调用外部协议
    let urlPrefixCallAppInIos = 'https://ios.upliveapps.com/goWindow'; // ios调用外部协议

    const native = {
        send(url) {
            if (!iframe) {
                iframe = document.createElement('iframe');
                iframe.id = 'up_callapp_iframe_' + Date.now();
                iframe.frameborder = '0';
                iframe.style.cssText = 'display:none;border:0;width:0;height:0;';
                document.body.appendChild(iframe);
            }
            iframe.src = url;
        },

        sendUriScheme(url) {
            window.location.href = url;
        },
        // 获得平台类型
        // weixin, weibo, qq, uplive，海外版本Android在URL Hash中添加标识 #pl=uplive
        getPlatform() {
            let [ua, pl] = [navigator.userAgent, 'other'];

            if (ua.match(/uplive/i) || localStorage.getItem('__inuplive__') || Uplib.url.query('pl') == 'uplive' || Uplib.url.query('pl', 'hash') == 'uplive') {
                pl = 'uplive';
            } else if (ua.match(/micromessenger/i)) {
                pl = 'wechat';
            } else if (ua.match(/qq/i)) {
                pl = 'qq';
            } else if (ua.match(/weibo/i)) {
                pl = 'weibo';
            } else if (ua.match(/renren/i)) {
                pl = 'renren';
            } else if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) {
                pl = 'fb';
            } else if (ua.match(/Line/i)) {
                pl = 'line';
            }

            return pl;
        },
        // 获得当前系统类型
        getSystem() {
            let ua = navigator.userAgent;
            return /(iPhone|iPad|iPod|iOS)/i.test(ua) ? 'ios' : /[aA]ndroid/i.test(ua) ? 'android' : 'pc';
        },

        // 系统语言
        getLanguage() {
            let language = navigator.language || navigator.browserLanguage;

            if (language) {
                let arr = language.split('-');
                arr[1] = arr[1].toUpperCase();
                language = arr.join('-');
            }

            return language;
        },

        // 检查api是否可用
        checkAvail({ apiname, errtip } = {}) {
            setTimeout(() => {
                if (!apiStatus[apiname] && errtip) {
                    if (typeof errtip == 'function') {
                        errtip();
                    } else {
                        alert(errtip);
                    }
                }
            }, 3000);
        },

        /**
         * 获取配置信息
         * @param cfg {
         *      invalid 0 usertoken失效；1第一次获取
         *      complete: function(){}
         * }
         *
         */
        getConfigs({ complete = () => {}, invalid = 0, errtip = '不支持' } = {}) {
            let self = this;
            let url = 'uplive://getConfigs?json=';
            let params = {
                invalid: invalid,
                receive: "UpH5Native['upliveapp_getConfigs']",
                jsCallback: 'UpH5Native.getConfigsComplete'
            }

            UpH5Native.getConfigsComplete = function(param) { // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            }

            this.send(url + JSON.stringify(params))
            this.checkAvail({
                apiname: 'getConfigs',
                errtip
            });
        },

        /**
         * 获取主播信息
         * @param cfg {
         *      complete: function(){}
         * }
         *
         */
        getHostInfo({ complete = () => {}, errtip = '不支持' } = {}) {
            let self = this;
            let url = 'uplive://getHostInfo?json=';
            let params = {
                receive: "UpH5Native['upliveapp_getHostInfo']",
                jsCallback: 'UpH5Native.getHostInfoComplete'
            }

            UpH5Native.getHostInfoComplete = function(param) {
                complete.call(self, JSON.parse(param));
            }

            this.send(url + JSON.stringify(params))
            this.checkAvail({
                apiname: 'getHostInfo',
                errtip
            });
        },

        // 上报提现结果给客户端
        acceptAgreement({ errtip = '不支持' } = {}) {
            let url = 'uplive://acceptAgreement?json=';
            let params = {
                receive: "UpH5Native['upliveapp_acceptAgreement']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'acceptAgreement',
                errtip
            });
        },
        /**
         * 跳转个人主页
         * @param cfg {
         *      uid: 10234, // {Number} 整型
         * }
         */
        profile({ uid = 0, errtip = '' } = {}) {
            let url = 'uplive://goWindow?json=';
            let params = {
                key: 'profile',
                extend: {
                    uid: parseInt(uid, 10)
                },
                receive: "UpH5Native['upliveapp_profile']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'profile',
                errtip,
            });
        },
        /**
         * 跳转到直播间
         * @param cfg {
         *      uid: 10234, // {Number} 整型
         *      roomid: 10234 {Number} 整型
         * }
         */
        goRoom({ uid = 0, roomid = 0, errtip = '' } = {}) {
            let url = 'uplive://goWindow?json=';
            let params = {
                key: 'room',
                extend: {
                    uid: parseInt(uid, 10),
                    roomid: parseInt(roomid, 10)
                },
                receive: "UpH5Native['upliveapp_goRoom']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goRoom',
                errtip,
            });
        },

        goRank({ name = 1, errtip = '' } = {}) {
            let url = 'uplive://goWindow?json=';
            let key;

            switch (parseInt(name, 10)) {
                case 1:
                    key = 'starank';
                    break;
                case 2:
                    key = 'hostrank';
                    break;
                case 3:
                    key = 'wealthrank';
                    break;
                default:
                    key = 'starank';
            }

            let params = {
                key: key,
                receive: "UpH5Native['upliveapp_goRank']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goRank',
                errtip,
            });
        },

        // 跳转充值界面
        gopay({ errtip = '', complete = () => {} } = {}) {
            let self = this;
            let url = 'uplive://goWindow?json=';
            let params = {
                key: 'pay',
                receive: "UpH5Native['upliveapp_gopay']",
                jsCallback: "UpH5Native['getGopayComplete']"
            };

            UpH5Native.getGopayComplete = function(param) {
                complete.call(self, JSON.parse(param));
            }

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'gopay',
                errtip,
            });
        },


        // 上报提现结果给客户端
        reportCashResult({ success = 1, errtip } = {}) {
            let url = 'uplive://h5cash?json=';
            let params = {
                success,
                receive: "UpH5Native['upliveapp_reportCashResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportCashResult',
                errtip
            });
        },

        // 上报充值结果给客户端
        reportPayResult({ success = 1, errtip } = {}) {
            let url = 'uplive://h5payment?json=';
            let params = {
                success,
                receive: "UpH5Native['upliveapp_reportPayResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportPayResult',
                errtip
            });
        },

        // 关闭webview
        closeWindow({ errtip = '' } = {}) {
            let url = 'uplive://closeWindow?json=';
            let params = {
                receive: "UpH5Native['upliveapp_closeWindow']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'closeWindow',
                errtip
            });
        },

        // 浏览器中打开
        openBrowser({ url = '', errtip = '' } = {}) {
            let _url = 'uplive://openBrowser?json=';
            let params = {
                receive: "UpH5Native['upliveapp_openBrowser']",
                url: url
            };

            this.send(_url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'openBrowser',
                errtip
            });
        },

        /**
         * 支付调用
         * @param data {object}
         *      - platform 支付平台
         *      - complete {function}
         *      - params 参数
         * @return this
         */
        pay({
            complete = () => {}, // 支付完成
            platform = 'wxpay', // 对个别平台定制字段
            productId = '', // 支付数据， productId 产品ID
            errtip = '不支持支付'
        } = {}) {
            let self = this;
            let _url = 'uplive://payment?json=';
            let _params = {
                receive: "UpH5Native['upliveapp_pay']",
                platform: platform || 'wxpay',
                params: {
                    productId: productId
                },
                jsCallback: 'UpH5Native.payComplete'
            };

            UpH5Native.payComplete = function(param) { // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'pay',
                errtip
            });
        },

        // 客户端分享
        share({
            complete = () => {},

            title = '分享标题',
            url = 'http://www.baidu.com',
            imageUrl = 'https://m.baidu.com/static/index/plus/plus_logo.png',
            desc = '分享表述',

            platform = {}, // 对个别平台定制字段

            errtip = '客户端不支持分享'
        } = {}) {

            let self = this;
            let _url = 'uplive://sharePage?json=';
            let pls = ['qq', 'qzone', 'wechat_friends', 'wechat_circle', 'sina', 'fb', 'tw'];
            let oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            let params = {
                receive: "UpH5Native['upliveapp_share']",
                platform: {},
                jsCallback: 'UpH5Native.upliveShareComplete'
            };

            pls.forEach(function(item, i) {
                params.platform[item] = {
                    url: url,
                    title: title,
                    imageUrl: imageUrl,
                    desc: desc
                };
            });

            if (JSON.stringify(platform) != '{}') {
                params = Object.assign(true, params, {
                    platform
                });
            }

            for (var i in params) {
                if (i == 'platform') {
                    for (var j in params[i]) {
                        for (var k in params[i][j]) {
                            if (k == 'title' || k == 'desc') {
                                params[i][j][k] = encodeURIComponent(params[i][j][k]);
                            }
                            if (k == 'url' && params[i][j][k] && oauthtype[j]) {
                                let url = params[i][j][k];

                                params[i][j][k] = Uplib.url.addParam(url, {
                                    oauthtype: oauthtype[j]
                                });
                            }
                        }
                    }
                }
            }

            UpH5Native.upliveShareComplete = function(param) {
                complete.call(self, JSON.parse(param));
            }
            this.send(_url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'share',
                errtip
            });
        },

        // 单渠道分享
        singleShare({
            complete = () => {},

            title = '分享标题',
            url = 'http://www.baidu.com',
            imageUrl = 'https://m.baidu.com/static/index/plus/plus_logo.png',
            desc = '分享表述',

            type = 'fb', // 对个别平台定制字段

            errtip = '客户端不支持分享'
        } = {}) {

            let self = this;
            let system = this.getSystem();
            let _url = 'uplive://singleShare?json=';
            let pls = ['qq', 'qzone', 'wechat_friends', 'wechat_circle', 'sina', 'fb', 'tw'];
            let oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            if (url && oauthtype[type]) {
                url = Uplib.url.addParam(url, {
                    oauthtype: oauthtype[type]
                });
            }
            if (type == 'sina') {
                desc += '>>' + url;
            }
            let params = {
                receive: "UpH5Native['upliveapp_singleShare']",
                platform: {
                    url: url,
                    title: system == 'ios' ? title : encodeURIComponent(title),
                    imageUrl: imageUrl,
                    desc: system == 'ios' ? desc : encodeURIComponent(desc)
                },
                type,
                jsCallback: 'UpH5Native.upliveSingleShareComplete'
            };

            UpH5Native.upliveSingleShareComplete = function(param) {
                complete.call(self, JSON.parse(param));
            }

            this.send(_url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'singleShare',
                errtip
            });
        },

        // 游客登录
        login({
            complete = () => {},
            errtip = '不支持登录'
        } = {}) {
            let self = this;
            let url = 'uplive://goLogin?json=';
            let params = {
                receive: "UpH5Native['upliveapp_login']",
                jsCallback: 'UpH5Native.loginComplete'
            }
            UpH5Native.loginComplete = function(param) {
                complete.call(self, JSON.parse(param));
            }
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'login',
                errtip
            });
        },

        // 刷新用户信息
        refreshProfile({ errtip = '不支持刷新用户信息' } = {}) {
            let url = 'uplive://refreshProfile?json=';
            let params = {
                receive: "UpH5Native['upliveapp_refreshProfile']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'refreshProfile',
                errtip
            });
        },

        setTitle({
            title = '',
            errtip = () => {}
        } = {}) {
            let self = this;
            let _url = 'uplive://setTitle?json=';
            let _params = {
                receive: "UpH5Native['upliveapp_setTitle']",
                params: {
                    title: title
                }
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'setTitle',
                errtip
            });
        },

        goCashRecord({ errtip = '不支持领取纪录' } = {}) {
            let url = 'uplive://goCashRecord?json=';
            let params = {
                receive: "UpH5Native['upliveapp_goCashRecord']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goCashRecord',
                errtip
            });
        },

        bindMobilePhone({
            complete = () => {},
            errtip = '不支持手机绑定'
        } = {}) {
            let self = this;
            let url = 'uplive://bindMobilePhone?json=';
            let params = {
                receive: "UpH5Native['upliveapp_bindMobilePhone']",
                jsCallback: 'UpH5Native.bindMobilePhoneComplete'
            }
            UpH5Native.bindMobilePhoneComplete = function(param) {
                complete.call(self, JSON.parse(param));
            }
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindMobilePhone',
                errtip
            });
        },

        bindWechat({
            complete = () => {},
            errtip = '不支持微信绑定'
        } = {}) {
            let self = this;
            let url = 'uplive://bindWechat?json=';
            let params = {
                receive: "UpH5Native['upliveapp_bindWechat']",
                jsCallback: 'UpH5Native.bindWechatComplete'
            }
            UpH5Native.bindWechatComplete = function(param) {
                complete.call(self, JSON.parse(param));
            }
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindWechat',
                errtip
            });
        }
    }

    for (let i in native) {
        UpH5Native['upliveapp_' + i] = function() {
            apiStatus[i] = 1;
        };
    }

    lib.native = native;

})(window, window.Uplib || (window.Uplib = {}));



// WEBPACK FOOTER //
// ./src/js/openjs/lib/native.js